import styled from 'styled-components'

export const DrawerContent = styled.div`
	padding: 20px;
	height: 100%;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
`

export const DrawerHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #e0e0e0;
`

export const DrawerTitle = styled.h2`
	margin: 0;
	font-size: 18px;
	font-weight: 600;
	color: #333;
`

export const CloseButton = styled.button`
	background: none;
	border: none;
	font-size: 24px;
	cursor: pointer;
	color: #666;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	transition: all 0.2s ease;

	&:hover {
		background-color: #f5f5f5;
		color: #333;
	}

	&:focus {
		outline: none;
		background-color: #f0f0f0;
	}
`

export const DrawerBody = styled.div`
	flex: 1;
	overflow-y: auto;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;

		&:hover {
			background: #a8a8a8;
		}
	}
`

export const DrawerFooter = styled.div`
	margin-top: 20px;
	padding-top: 15px;
	border-top: 1px solid #e0e0e0;
	display: flex;
	justify-content: flex-end;
	gap: 10px;

	button {
		padding: 8px 16px;
		border: 1px solid #ddd;
		border-radius: 4px;
		background: white;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background-color: #f8f9fa;
			border-color: #adb5bd;
		}

		&.primary {
			background-color: #007bff;
			border-color: #007bff;
			color: white;

			&:hover {
				background-color: #0056b3;
				border-color: #004085;
			}
		}

		&.danger {
			background-color: #dc3545;
			border-color: #dc3545;
			color: white;

			&:hover {
				background-color: #c82333;
				border-color: #bd2130;
			}
		}
	}
`

export const DrawerOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.4);
	z-index: 999;
`
